import {PriceModel} from '../Price.model';
import {BreakdownModel} from './Breakdown.model';
import {ModelContext} from '../../../types/app.types';
import {ItemPricingInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class PricingModel {
  public unitPrice: PriceModel;
  public totalPrice: PriceModel;
  public priceUndetermined: boolean;
  public breakdown: BreakdownModel;

  constructor(params: PricingModel) {
    this.unitPrice = params.unitPrice;
    this.totalPrice = params.totalPrice;
    this.priceUndetermined = params.priceUndetermined;
    this.breakdown = params.breakdown;
  }
  public static fromCartV1({
    unitPrice,
    totalPrice,
    priceUndetermined,
    comparePrice,
    comparePriceByQuantity,
    basePrice,
    totalModifiersPrice,
  }: {
    unitPrice: PriceModel;
    totalPrice: PriceModel;
    priceUndetermined: boolean;
    comparePrice?: PriceModel;
    comparePriceByQuantity?: PriceModel;
    basePrice?: PriceModel;
    totalModifiersPrice?: PriceModel;
  }) {
    return new PricingModel({
      unitPrice,
      totalPrice,
      priceUndetermined,
      breakdown: BreakdownModel.fromCartV1({comparePrice, comparePriceByQuantity, basePrice, totalModifiersPrice}),
    });
  }

  public static fromCartV2(pricing: ItemPricingInfo, quantity: number, modelContext: ModelContext): PricingModel {
    return new PricingModel({
      unitPrice: PriceModel.fromCartV2(pricing.unitPrice, modelContext),
      totalPrice: PriceModel.fromCartV2(pricing.totalPrice, modelContext),
      priceUndetermined: pricing.priceUndetermined ?? /* istanbul ignore next */ false,
      breakdown: BreakdownModel.fromCartV2(pricing.breakdown, pricing.unitPrice, quantity, modelContext),
    });
  }
}
